import React, { useState } from 'react';
import { BtnFullScreenBi } from '../BtnFullScreenBi/BtnFullScreenBi';
import env from '../../../env';
import { Button } from 'react-bootstrap';
import './BIRender.css';
import { filter } from 'lodash';
import { screenSizeHeightBI } from '../../helpers/getSizeScreen';

export function BIRender({ filters, reportSection, ticket = false }) {
    const sizeBi = 1.25
    const [myHeigth, setMyHeight] = useState(screenSizeHeightBI(sizeBi));
    const [originalHeight, setOriginalHeight] = useState(screenSizeHeightBI(sizeBi));

    /**
     * Set height in frame
     * @param {string} height 
     * @param {boolean} setOriginalHeight
     */
    function handleHeight(height = 600, rollBackToOriginalHeight = false) {
        if (!rollBackToOriginalHeight) {
            setMyHeight(height);
        } else {
            setMyHeight(originalHeight)
        }
        console.log('filter', filters);
    }

    return (
        <div id="divFullScreen">
            {
                myHeigth === originalHeight &&
                <a target='_blank' style={{ marginBottom: '20px', display: 'inline-block' }} href={`${env.urlBI}&pageName=${reportSection}${filters}`} rel="noreferrer">
                    <Button variant={'primary'} size={'sm'}>Acesso iPad</Button>
                </a>
            }
            <BtnFullScreenBi idElement="divFullScreen" handleHeight={(height, rollBackToOriginalHeight) => handleHeight(height, rollBackToOriginalHeight)} hasBtnText={true} animateBtn={true} posBtnActive="posLeft" dirBtnText="dirRight" styles={{ top: '-10px', left: '50%', transform: 'translateX(-50%)', width: '54px', height: '54px', br: '0 10px 10px 0' }} />
            <iframe width="100%" height={myHeigth} src={`${ticket === true ? env.urlBiTickets : env.urlBI}&pageName=${reportSection}${filters}&navContentPaneEnabled=false`} frameBorder="0" allowFullScreen={true}></iframe>
        </div>
    );

}
